import Modal from '@components/v2/ui/Modal/Modal';
import { Share } from 'lucide-react';
import { memo } from 'react';
import { ShareEntityModalProps } from './types/sharedEntities.types';

const SharedEntitiesModal = ({
  isOpen,
  onClose,
  title,
  content = null,
  footer,
  testId,
}: ShareEntityModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      size="expanded"
      testId={testId}
      onClose={onClose}
      header={{ title, icon: Share }}
      footer={footer}
    >
      {content}
    </Modal>
  );
};

export default memo(SharedEntitiesModal);
